// extracted by mini-css-extract-plugin
export var aboutContent = "about-module--about-content--0dliq";
export var mailingListSignupWrapper = "about-module--mailing-list-signup-wrapper--8hrrH";